import { useTranslation } from 'react-i18next';

import { LoginForm } from './LoginForm';
import { LoginFrame } from './LoginFrame';

export type LoginWidgetProps = {
  introductionText?: string;
  isSso: boolean;
  loginError?: string;
  onEnterValidEmail?: (email: string) => void;
  onLoginSubmit: (email: string, pw: string) => void;
  onResetPassword: (email: string) => void;
};

/**
 * Login Widget component
 */
export function LoginWidget({
  introductionText,
  isSso,
  loginError,
  onEnterValidEmail,
  onLoginSubmit,
  onResetPassword,
}: LoginWidgetProps) {
  const { t } = useTranslation();

  return (
    <LoginFrame title={t('app.loginWidget.title')}>
      <LoginForm
        loginError={loginError}
        introductionText={introductionText}
        isSso={isSso}
        onClickForgotPwButton={onResetPassword}
        onEnterValidEmail={onEnterValidEmail}
        onSubmit={onLoginSubmit}
      />
    </LoginFrame>
  );
}
